<template>
  <OverseasNav />
  <section id="overseas" class="overseas">
    <div class="container">
      <router-view />
      <OverseasFooter />
    </div>
  </section>
  <OverseaModal />
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import OverseasNav from '@template/overseas/_component/nav.vue';
import OverseasFooter from '@template/overseas/_component/footer.vue';
import OverseaModal from '@template/overseas/_component/modal/index.vue';

export default {
  name: 'overseas',
  components: {
    OverseasNav,
    OverseasFooter,
    OverseaModal
  },
  data(): DataInterface {
    return {
      setTime: {
        anchor: 0
      },
      expand: {
        style: {
          id: 'style_mouse',
          dom: null
        }
        
      }
    };
  },
  watch: {
    $route: {
      handler(newData: any, oldDate: any): void {
        newData.path !== oldDate.path && this.scrollTo();
        newData.hash && this.scrollAnchor();
      }
    }
  },
  mounted(): void {
    this.scrollTo();
    this.scrollAnchor();
    addEventListener('mousemove', this.listenMouseMove, false);
    addEventListener('scroll', this.listenScroll, false);
  },
  beforeUnmount(): void {
    removeEventListener('mousemove', this.listenMouseMove, false);
    removeEventListener('scroll', this.listenScroll, false);
  },
  methods: {
    /**
     * 滚动
     * @param {number} x 横向滚动条位置
     * @param {number} y 纵向滚动条位置
     */
    scrollTo(x: number = 0, y: number = 0): void {
      if (y === 0) {
        scrollTo(x, y);
      } else {
        $FN.SmoothTransition({
          start: scrollY,
          end: y,
          callback: (current: number) => {
            scrollTo(x, current);
          }
        });
      }
    },
    
    /**
     * 滚动至锚点
     */
    scrollAnchor(): void {
      let hash = this.$route.hash;
      
      if (hash === '') return;
      hash = hash.split('#')[1];
      
      this.$router.replace({ hash: '' });
      
      this.setTime.anchor !== 0 && clearTimeout(this.setTime.anchor);
      this.setTime.anchor = setTimeout(() => {
        let dom: HTMLElement = null;
        
        this.setTime.anchor = 0;
        dom = document.getElementsByName(hash)[0];
        
        if (!dom) return;
        
        this.$nextTick(() => {
          this.scrollTo(0,
            dom.offsetTop - (
              $Store.Public().width >= $Enum.GridEnum.XL
                ? (dom.offsetTop < $Store.Public().scroll.y ? 80 : 0)
                : 60
            )
          );
        });
      }, 150);
    },
    
    /**
     * 监听鼠标移动
     */
    listenMouseMove(event: any): void {
      let x = (event.clientX || 0) - $Store.Public().width / 2,
        y = (event.clientY || 0) - $Store.Public().height / 2;
      
      if ($FN.Agent.client() !== 'PC') return;
      
      x <= -500 && (x = -500);
      x >= 500 && (x = 500);
      y <= -500 && (y = -500);
      y >= 500 && (y = 500);
      
      if (!this.expand.style.dom) {
        this.expand.style.dom = document.getElementById(this.expand.style.id);
        
        if (!this.expand.style.dom) {
          this.expand.style.dom = document.createElement('style');
          this.expand.style.dom.id = this.expand.style.id;
          document.head.append(this.expand.style.dom);
        }
      }
      
      this.expand.style.dom.innerHTML = `
            :root {
            --mouse-x: ${ x }px;
            --mouse-y: ${ y }px;
            }
            `;
    },
    
    /**
     * 监听滚动
     */
    listenScroll(): void {
      $Store.Public().updateScroll(
        document.documentElement.scrollLeft,
        document.documentElement.scrollTop
      );
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

.overseas {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  
  .container {
    overflow: hidden;
    position: relative;
    width: 100%;
  }
}
</style>